import {Component, inject, computed, signal} from '@angular/core';
import {CdkDrag, CdkDragDrop, CdkDropList} from '@angular/cdk/drag-drop';
import {IItem} from '../../../../types/IItem';
import {ResultsFooterCompareCardComponent} from './results-footer-compare-card/results-footer-compare-card.component';
import {IconsComponent} from '../../../../shared/components/icons/icons.component';
import {ButtonComponent} from '../../../../shared/components/button/button.component';
import {ResultsStore} from '../../../../shared/store/results.store';
import {EventService} from '../../../../shared/services/event.service';
import {Number} from '../../../../shared/components/number/number';
import {BottomDrawerComponent} from '../../../../shared/components/bottom-drawer/bottom-drawer.component';
import {Alert} from '../../../../shared/components/alert/alert';

@Component({
  selector: 'app-results-footer',
  standalone: true,
  imports: [CdkDropList, CdkDrag, ResultsFooterCompareCardComponent, IconsComponent, ButtonComponent, Number, BottomDrawerComponent, Alert],
  templateUrl: './results-footer.component.html',
  styleUrl: './results-footer.component.css'
})
export class ResultsFooterComponent {
  public levels = ['good', 'better', 'best'] as const;
  public resultsStore = inject(ResultsStore);
  private eventService = inject(EventService);

  isDrawerOpen = signal(false);

  private selectedItems = computed(() =>
    Object.values(this.resultsStore.compare_items()).filter((item): item is IItem => !!item)
  );

  compareItemCount = computed(() => this.selectedItems().length);

  allQuantitiesSourced = computed(() => {
    const items = this.selectedItems();
    if (items.length === 0) return false;

    const totalQuantity = items.reduce((carry, item) => carry + item.sourcing.reduce((sum, {selected_quantity}) => sum + selected_quantity, 0), 0);
    return totalQuantity / items.length === this.resultsStore.quantity();
  });

  drop(level: 'good' | 'better' | 'best', event: CdkDragDrop<IItem[]>) {
    this.resultsStore.addCompareItem(event.item.data, level);
  }

  clearAllSelections() {
    this.resultsStore.clearCompare();
  }

  compareSelected() {
    this.eventService.emit('compare-items', {items: this.resultsStore.compare_items()});
  }

  getConnectedLists(level: string): string[] {
    return this.levels.filter(l => l !== level).map(l => `compare-${l}`);
  }
}
